interface NdviBadgeProps {
  value: number;
  showValue?: boolean;
}

function getNdviBadge(ndvi: number): { label: string; color: string; bg: string } {
  if (ndvi < 0) return { label: '비식생', color: '#fff', bg: '#e74c3c' };
  if (ndvi < 0.2) return { label: '약한 식생', color: '#333', bg: '#f1c40f' };
  if (ndvi < 0.4) return { label: '보통 식생', color: '#333', bg: '#a9d65b' };
  if (ndvi < 0.6) return { label: '건강한 식생', color: '#fff', bg: '#27ae60' };
  return { label: '매우 건강', color: '#fff', bg: '#1a7a40' };
}

export { getNdviBadge };

export default function NdviBadge({ value, showValue = true }: NdviBadgeProps) {
  const badge = getNdviBadge(value);
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap"
      style={{ backgroundColor: badge.bg, color: badge.color }}
    >
      {showValue && <span>{Number(value).toFixed(4)}</span>}
      <span>{badge.label}</span>
    </span>
  );
}
